import React from 'react';
import { CheckCircle2, Sparkles } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

interface ApprovalEmptyStateProps {
  className?: string;
}

export function ApprovalEmptyState({ className = '' }: ApprovalEmptyStateProps) {
  return (
    <Card data-tour="approvals-first-row" className={`border-dashed ${className}`}>
      <CardContent className="flex flex-col items-center justify-center py-16 px-6">
        {/* Icon with gradient background */}
        <div className="relative mb-6">
          <div className="absolute inset-0 bg-green-500/20 rounded-full blur-2xl" />
          <div className="relative bg-green-50 dark:bg-green-950/30 rounded-full p-6">
            <CheckCircle2 className="h-16 w-16 text-green-600 dark:text-green-500" />
          </div>
          <div className="absolute -top-1 -right-1">
            <Sparkles className="h-6 w-6 text-green-500 animate-pulse" />
          </div>
        </div>

        {/* Main message */}
        <h3 className="text-2xl font-semibold text-center mb-3">
          All Clear! 🎉
        </h3>
        
        {/* Description */}
        <p className="text-center text-muted-foreground max-w-md mb-2">
          Excellent work! You've successfully reviewed all pending timesheets.
        </p>
        
        <p className="text-center text-sm text-muted-foreground max-w-md">
          New submissions will appear here when employees submit their timesheets for approval.
        </p>

        {/* Optional decorative element */}
        <div className="mt-8 flex items-center gap-2 text-xs text-muted-foreground">
          <div className="h-px w-12 bg-border" />
          <span>No pending approvals</span>
          <div className="h-px w-12 bg-border" />
        </div>
      </CardContent>
    </Card>
  );
}
